import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ShipmentPlannerProfileItemFacade } from './shipment-planner-profile-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileItemGuard {
  constructor(private shipmentPlannerProfileItemFacade: ShipmentPlannerProfileItemFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.shipmentPlannerProfileItemFacade.isDefaultProfileApplicable$.pipe(
      take(1),
      map((isApplicable: boolean) => {
        if (isApplicable) {
          this.shipmentPlannerProfileItemFacade.loadDefaultProfile();
        }

        return true;
      }),
    );
  }
}
